import {Component, Input} from '@angular/core';
import {StepConfig} from '@core/types';

@Component({
  selector: 'core-stepper',
  imports: [],
  templateUrl: './stepper.html',
  styleUrl: './stepper.scss',
  standalone: true,
  host: {
    style: 'width: 100%;'
  }
})
export class Stepper {

  @Input()
  steps: StepConfig[] = [];

  get progress(): string {
    const index = this.steps.findIndex(step => step.status === 'in-progress');
    if (index <= 0) return '0%';
    return `${100 * index / (this.steps.length - 1)}%`;
  }

  get lineInsetPercent(): number {
    if (this.steps.length <= 1) return 0;
    return 50 / this.steps.length;
  }

}
